module.exports = __webpack_public_path__ + "static/media/PromoImage_Loyalty.14bc6642.png";